(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const quickAddButtons = document.querySelectorAll('[data-product-id]');

    quickAddButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const productId = this.dataset.productId;
        console.log('Quick add clicked for product:', productId);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["guarantee"] && !Shopify.designMode) return;
  try {
    
  // Scroll reveal animation
  document.addEventListener('DOMContentLoaded', function() {
    const revealElements = document.querySelectorAll('.guarantee-premium .reveal');

    const revealOnScroll = () => {
      revealElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 100;

        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/**
 * Premium Header Controller
 * Handles mobile drawer, scroll behavior, and animations
 */
(function() {
  'use strict';

  const header = document.querySelector('[data-header]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  const drawerClose = document.querySelector('[data-drawer-close]');
  const cartBadge = document.querySelector('[data-cart-badge]');

  if (!header) return;

  // State
  let lastScrollY = 0;
  let ticking = false;
  const SCROLL_THRESHOLD = 50;
  const HIDE_THRESHOLD = 150;

  /**
   * Update header state based on scroll position
   */
  function updateHeaderOnScroll() {
    const currentScrollY = window.scrollY;

    // At top vs scrolled
    if (currentScrollY > SCROLL_THRESHOLD) {
      header.classList.add('header--scrolled');
      header.classList.remove('header--at-top');
    } else {
      header.classList.remove('header--scrolled');
      header.classList.add('header--at-top');
    }

    // Hide/show on scroll direction (only after threshold)
    if (currentScrollY > HIDE_THRESHOLD) {
      if (currentScrollY > lastScrollY + 10) {
        // Scrolling down
        header.classList.add('header--hidden');
      } else if (currentScrollY < lastScrollY - 10) {
        // Scrolling up
        header.classList.remove('header--hidden');
      }
    } else {
      header.classList.remove('header--hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  /**
   * Optimized scroll handler with requestAnimationFrame
   */
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateHeaderOnScroll);
      ticking = true;
    }
  }

  /**
   * Open mobile drawer
   */
  function openDrawer() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-visible');
    menuToggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');

    // Focus management
    setTimeout(() => {
      const firstLink = drawer.querySelector('.mobile-drawer__link');
      if (firstLink) firstLink.focus();
    }, 400);
  }

  /**
   * Close mobile drawer
   */
  function closeDrawer() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-visible');
    menuToggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');

    // Return focus to toggle
    menuToggle.focus();
  }

  /**
   * Toggle drawer state
   */
  function toggleDrawer() {
    const isOpen = drawer.classList.contains('is-open');
    if (isOpen) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  /**
   * Handle keyboard events
   */
  function handleKeydown(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  }

  /**
   * Initialize
   */
  function init() {
    // Scroll listener
    window.addEventListener('scroll', onScroll, { passive: true });

    // Menu toggle
    if (menuToggle) {
      menuToggle.addEventListener('click', toggleDrawer);
    }

    // Close button
    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    // Backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }

    // Escape key
    document.addEventListener('keydown', handleKeydown);

    // Close drawer on navigation link click
    const drawerLinks = drawer.querySelectorAll('.mobile-drawer__link, .mobile-drawer__cta-btn, .mobile-drawer__secondary-link');
    drawerLinks.forEach(link => {
      link.addEventListener('click', () => {
        setTimeout(closeDrawer, 150);
      });
    });

    // Initial scroll state
    updateHeaderOnScroll();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-coverage"] && !Shopify.designMode) return;
  try {
    
  // Scroll reveal animation
  document.addEventListener('DOMContentLoaded', function() {
    const revealElements = document.querySelectorAll('.press-coverage-premium .reveal');

    const revealOnScroll = () => {
      revealElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 100;

        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('active');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    // 3D Tilt effect on magazine cards
    const magazineCards = document.querySelectorAll('[data-tilt]');

    magazineCards.forEach(card => {
      const inner = card.querySelector('.magazine-card__inner');
      if (!inner) return;

      card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        const rotateX = (y - centerY) / 20;
        const rotateY = (centerX - x) / 20;

        inner.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-16px)`;
      });

      card.addEventListener('mouseleave', () => {
        inner.style.transform = '';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials-premium"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const videoCards = document.querySelectorAll('.video-testimonials-premium .video-card');

    videoCards.forEach(card => {
      const video = card.querySelector('.video-player');
      const playBtn = card.querySelector('.video-play-btn');

      if (!video || !playBtn) return;

      playBtn.addEventListener('click', function(e) {
        e.preventDefault();

        if (video.paused) {
          // Pause all other videos
          document.querySelectorAll('.video-testimonials-premium .video-player').forEach(v => {
            if (v !== video) {
              v.pause();
              v.closest('.video-card').classList.remove('playing');
            }
          });

          video.play().catch(err => console.log('Video play error:', err));
          card.classList.add('playing');
        } else {
          video.pause();
          card.classList.remove('playing');
        }
      });

      video.addEventListener('click', function() {
        if (!video.paused) {
          video.pause();
          card.classList.remove('playing');
        }
      });

      video.addEventListener('ended', function() {
        card.classList.remove('playing');
      });

      // Show native controls on mobile
      if (window.innerWidth <= 768) {
        video.setAttribute('controls', 'controls');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
